// extracted by mini-css-extract-plugin
export default {"containerTerminal":"FormFrontImage_containerTerminal__3cWpn","containerIcon":"FormFrontImage_containerIcon__yjSqJ"};